import { defineMessages } from 'react-intl';

export const messages: {
	searchSuggestionsDropdownLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	searchSuggestionsDropdownLabel: {
		id: 'dynamic-cards-search-page.dropdown.search-suggestions-label',
		defaultMessage: 'Search Suggestions Dropdown',
		description: 'Accessibility label for the search suggestions dropdown',
	},
});
